import {
  useFirstTimeLogin,
  useSetupIntercom,
  useVisitTimestamps,
} from "@/features/account-management";
import { FileToStorydocGenerationManager } from "@/dialogs/file-to-storydoc-dialog/global/file-to-storydoc-generation-manager";
import { useInitAnalytics } from "@/features/analytics";
import { MfaEnforcementDialog } from "@/features/authentication/shared/components/mfa-enforcement-dialog";
import { useRoleReconcile } from "@/features/authentication/shared/hooks/use-role-reconcile";
import { useWizardFlow } from "@/features/wizard";
import { FeatureFlagsProvider } from "@/lib/feature-flags";
import { useGetCurrentUserQuery } from "@/shared/services";
import { useGetOrgInfoQuery } from "@api/accounts";
import DeckBuildRunner from "@pages/how-to-start/deck-build-runner";

export const SetupProvider = ({ children }: { children: React.ReactNode }) => {
  useGetOrgInfoQuery({});
  useGetCurrentUserQuery();
  useRoleReconcile();
  useInitAnalytics();
  useVisitTimestamps();
  useFirstTimeLogin();
  useWizardFlow();
  useSetupIntercom();
  return (
    <FeatureFlagsProvider>
      {children}
      <MfaEnforcementDialog />
      <DeckBuildRunner />
      <FileToStorydocGenerationManager />
    </FeatureFlagsProvider>
  );
};
